import {
  CategoryInfo,
  GetTablesTaggingStatusResponse,
} from "@/apis/workbook/types";

/**
 * 카테고리에 태깅된 셀이 있는지 확인합니다.
 */
export const isCategoryTagged = (
  category: CategoryInfo,
  taggingStatusData?: GetTablesTaggingStatusResponse,
) => {
  if (!taggingStatusData?.tables || category.tables.length === 0) {
    return false;
  }

  return category.tables.some((table) => {
    const status = taggingStatusData.tables.find((t) => t.tableId === table.id);
    return status?.hasTaggedCells === true;
  });
};
